<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <ChemicalClassifications />
    </div>
</template>

<script>
import currentUserQuery from '@views/ChemicalClassifications/Browse/queryCurrentUser.graphql';

import ChemicalClassifications from '../ChemicalClassifications/Browse.vue';

export default {
  name: 'ChemicalClassificationsContainer',
  components: {
    ChemicalClassifications,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
